module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sd-panel",
    class: {
      'visible': _vm.visible
    }
  }, [_c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('i', {
    staticClass: "el-icon-back",
    on: {
      "click": _vm.handleBack
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("AI生成")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('div', {
    staticClass: "upload-section"
  }, [_c('div', {
    staticClass: "section-header",
    on: {
      "click": _vm.toggleUploadSection
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    class: ['el-icon-arrow-down', {
      'is-active': !_vm.uploadSectionCollapsed
    }]
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.uploadSectionCollapsed),
      expression: "!uploadSectionCollapsed"
    }],
    staticClass: "section-content"
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    staticClass: "left-section"
  }, [(_vm.selectedWorkflow.inputNodes && _vm.selectedWorkflow.inputNodes.length > 0) ? _c('div', {
    staticClass: "dynamic-inputs"
  }, _vm._l((_vm.showInputNodes), function(node) {
    return _c('div', {
      key: node.nodeId,
      staticClass: "input-node"
    }, [(node.fieldValue === 'text') ? _c('div', {
      staticClass: "text-input"
    }, [_c('el-input', {
      attrs: {
        "type": "textarea",
        "autosize": {
          minRows: 2,
          maxRows: 2
        },
        "placeholder": ("请输入" + (node.fieldLabel||'提示词'))
      },
      model: {
        value: (_vm.inputNodeValues[node.nodeId + '_' + node.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.inputNodeValues, node.nodeId + '_' + node.fieldName, $$v)
        },
        expression: "inputNodeValues[node.nodeId + '_' + node.fieldName]"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.sourceImageUrl[node.nodeId]) ? _c('div', {
      staticClass: "image-actions"
    }, [_c('el-tooltip', {
      attrs: {
        "content": "删除后重新上传",
        "placement": "top"
      }
    }, [_c('i', {
      staticClass: "el-icon-delete",
      staticStyle: {
        "color": "#ffffff"
      },
      on: {
        "click": function($event) {
          return _vm.handleDeleteSourceImage(node.nodeId, node.fieldName)
        }
      }
    })])], 1) : _vm._e(), _vm._v(" "), (node.fieldValue === 'image') ? _c('div', {
      staticClass: "image-upload"
    }, [_c('el-upload', {
      ref: ("upload-" + (node.nodeId)),
      refInFor: true,
      staticClass: "upload-container",
      attrs: {
        "action": "",
        "auto-upload": false,
        "show-file-list": false,
        "on-change": function (file) { return _vm.handleImageChange(file, node.nodeId, node.fieldName); },
        "before-upload": _vm.beforeUpload,
        "limit": 1,
        "multiple": false,
        "accept": "image/*,video/mp4,image/gif"
      }
    }, [_c('div', {
      staticClass: "upload-area"
    }, [(!_vm.sourceImageUrl[node.nodeId]) ? [_c('div', {
      staticClass: "upload-content"
    }, [_c('i', {
      staticClass: "el-icon-plus"
    }), _vm._v(" "), _c('div', {
      staticClass: "upload-text"
    }, [_vm._v("点击上传" + _vm._s(node.fieldLabel || '图片'))])])] : _c('div', {
      staticClass: "preview-container"
    }, [(_vm.uploading[node.nodeId]) ? _c('div', {
      staticClass: "upload-loading"
    }, [_c('i', {
      staticClass: "el-icon-loading"
    })]) : [(_vm.sourceFileType[node.nodeId] === 'image') ? _c('el-image', {
      staticClass: "preview-image",
      attrs: {
        "src": _vm.sourceImageUrl[node.nodeId],
        "fit": "contain"
      }
    }) : (_vm.sourceFileType[node.nodeId] === 'video') ? _c('video', {
      staticClass: "preview-video",
      attrs: {
        "src": _vm.sourceImageUrl[node.nodeId],
        "controls": "",
        "autoplay": "",
        "loop": "",
        "muted": ""
      },
      domProps: {
        "muted": true
      }
    }) : (_vm.sourceFileType[node.nodeId] === 'gif') ? _c('el-image', {
      staticClass: "preview-image gif-preview",
      attrs: {
        "src": _vm.sourceImageUrl[node.nodeId],
        "fit": "contain"
      }
    }) : _vm._e()]], 2)], 2)])], 1) : (typeof node.fieldValue === 'object' && node.fieldValue.type === 'select') ? _c('div', {
      staticClass: "select-input"
    }, [_c('el-select', {
      attrs: {
        "clearable": "",
        "placeholder": ("请选择" + (node.fieldLabel||''))
      },
      model: {
        value: (_vm.inputNodeValues[node.nodeId + '_' + node.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.inputNodeValues, node.nodeId + '_' + node.fieldName, $$v)
        },
        expression: "inputNodeValues[node.nodeId + '_' + node.fieldName]"
      }
    }, _vm._l((node.fieldValue.options), function(option) {
      return _c('el-option', {
        key: option.value,
        attrs: {
          "label": option.label,
          "value": option.value
        }
      })
    }), 1)], 1) : _vm._e()])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "action-wrapper"
  }, [_c('div', {
    staticClass: "select-workflow"
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择工作流"
    },
    on: {
      "change": _vm.handleWorkflowChange
    },
    model: {
      value: (_vm.selectedWorkflowId),
      callback: function($$v) {
        _vm.selectedWorkflowId = $$v
      },
      expression: "selectedWorkflowId"
    }
  }, _vm._l((_vm.workflows), function(item) {
    return _c('el-option', {
      key: item.workflowId,
      attrs: {
        "label": item.name + '[消耗' + item.price + '点]',
        "value": item.workflowId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper"
  }, [_c('el-tooltip', {
    attrs: {
      "content": "生成图片",
      "placement": "top"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "warning",
      "loading": _vm.generatingImage
    },
    on: {
      "click": _vm.handleRunningUp
    }
  }, [_vm._v("运行")])], 1)], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "task-list"
  }, [_vm._l((_vm.tasks), function(task) {
    return _c('div', {
      key: task.taskId,
      staticClass: "task-item"
    }, [_c('div', {
      staticClass: "task-header"
    }, [_c('div', {
      staticClass: "task-type-tag",
      class: task.type + '-tag'
    }, [_vm._v("\n                        " + _vm._s(_vm.getWorkflowTypeLabel(task.type)) + "\n                    ")]), _vm._v(" "), _c('span', {
      staticClass: "task-name"
    }, [_vm._v(_vm._s(task.name))]), _vm._v(" "), _c('div', {
      staticClass: "task-info"
    }, [_c('span', {
      staticClass: "task-time"
    }, [_vm._v(_vm._s(task.createTime))]), _vm._v(" "), _c('span', {
      staticClass: "task-status",
      class: task.status
    }, [_vm._v("\n                            " + _vm._s(_vm.getTaskStatus(task)) + "\n                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "task-images"
    }, _vm._l((task.images), function(image, index) {
      return _c('div', {
        key: index,
        staticClass: "image-item"
      }, [(image.fileType === 'mp4') ? [_c('video', {
        staticClass: "video-preview",
        staticStyle: {
          "width": "100%",
          "height": "120px",
          "object-fit": "cover"
        },
        attrs: {
          "src": image.fileUrl,
          "controls": ""
        }
      })] : [_c('el-image', {
        attrs: {
          "src": image.fileUrl,
          "fit": "cover",
          "preview-src-list": [image.fileUrl]
        }
      })], _vm._v(" "), _c('div', {
        staticClass: "image-item-actions"
      }, [_c('el-tooltip', {
        attrs: {
          "content": "下载",
          "placement": "top"
        }
      }, [_c('i', {
        staticClass: "el-icon-download",
        staticStyle: {
          "color": "#ffffff"
        },
        on: {
          "click": function($event) {
            return _vm.handleDownloadImage(image)
          }
        }
      })]), _vm._v(" "), _c('el-tooltip', {
        attrs: {
          "content": "保存",
          "placement": "top"
        }
      }, [_c('i', {
        staticClass: "el-icon-folder-add",
        staticStyle: {
          "color": "#ffffff"
        },
        on: {
          "click": function($event) {
            return _vm.handleSaveImage(task.type, image)
          }
        }
      })])], 1)], 2)
    }), 0)])
  }), _vm._v(" "), (_vm.hasMore) ? _c('div', {
    staticClass: "load-more",
    on: {
      "click": _vm.loadMoreTasks
    }
  }, [_vm._v("加载更多")]) : _vm._e()], 2)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog save-dialog",
    attrs: {
      "title": "保存到",
      "visible": _vm.saveDialogVisible,
      "width": "600px",
      "modal-append-to-body": false,
      "append-to-body": true,
      "z-index": 3000
    },
    on: {
      "update:visible": function($event) {
        _vm.saveDialogVisible = $event
      },
      "close": _vm.handleDialogClose
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 80px"
    }
  }, [_c('el-form', {
    ref: "saveForm",
    staticClass: "body",
    attrs: {
      "model": _vm.saveForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所在文件夹",
      "prop": "folderId"
    }
  }, [_c('el-select', {
    staticClass: "folder-select",
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "请选择文件夹",
      "popper-class": "folder-select-dropdown"
    },
    model: {
      value: (_vm.saveForm.folderId),
      callback: function($$v) {
        _vm.$set(_vm.saveForm, "folderId", $$v)
      },
      expression: "saveForm.folderId"
    }
  }, _vm._l((_vm.flattenedDirectory), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.pathName,
        "value": item.id
      }
    }, [_c('span', {
      staticClass: "folder-path"
    }, [_vm._v(_vm._s(item.pathName))])])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "fileName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "placeholder": "请输入文件名",
      "maxlength": 50,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.saveForm.fileName),
      callback: function($$v) {
        _vm.$set(_vm.saveForm, "fileName", $$v)
      },
      expression: "saveForm.fileName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.saveDialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary",
      "loading": _vm.saving
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("确 定")])], 1)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('i', {
    staticClass: "el-icon-circle-plus"
  }), _vm._v(" "), _c('span', [_vm._v("上传图片")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2830309a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ai/SDUi.vue
// module id = 377
// module chunks = 0